import type {SVGProps} from 'react'

const SvgGas = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 24 24'}
    {...props}
  >
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M6.75 7a2.625 2.625 0 0 1 2.625-2.625h5A2.625 2.625 0 0 1 17 7v12.625H6.75zm2.625-1.375C8.615 5.625 8 6.241 8 7v11.375h7.75V7c0-.76-.616-1.375-1.375-1.375z'}
      clipRule={'evenodd'}
    />
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M18 19.625H6v-1.25h12zM13.12 9.625h-3v-1.25h3zM19.195 6.254l1.338 3.122c.14.327.212.679.212 1.035V15a1.625 1.625 0 0 1-3.25 0v-2h1.25v2a.375.375 0 0 0 .75 0v-4.59c0-.186-.038-.37-.111-.541l-1.338-3.123z'}
      clipRule={'evenodd'}
    />
  </svg>
)
export default SvgGas
